"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyProgressStatus = void 0;

const react_1 = __importDefault(require("react"));

const CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));

const Error_1 = __importDefault(require("@mui/icons-material/Error"));

const SskyCircularProgress_1 = __importDefault(require("../SskyCircularProgress/SskyCircularProgress"));

const SskyProgressStatus = props => {
  return react_1.default.createElement("div", {
    className: props.className
  }, props.status === "loading" && react_1.default.createElement(SskyCircularProgress_1.default, {
    className: props.status,
    size: 20
  }), props.status === "success" && react_1.default.createElement(CheckCircle_1.default, {
    className: props.status,
    style: {
      color: "#339900"
    }
  }), props.status === "error" && react_1.default.createElement(Error_1.default, {
    className: props.status,
    style: {
      color: "#ff3333"
    }
  }));
};

exports.SskyProgressStatus = SskyProgressStatus;
exports.default = react_1.default.memo(SskyProgressStatus);